import { createObjectSnapshotChanges } from './snapshot-changes';
export function createObjectReference(query) {
    return {
        query: query,
        snapshotChanges: createObjectSnapshotChanges(query),
        update: function (data) { return query.ref.update(data); },
        set: function (data) { return query.ref.set(data); },
        remove: function () { return query.ref.remove(); },
        valueChanges: function () {
            return createObjectSnapshotChanges(query)()
                .map(function (action) { return action.payload.exists() ? action.payload.val() : null; });
        },
    };
}
//# sourceMappingURL=create-reference.js.map


//////////////////
// WEBPACK FOOTER
// /Users/makebetter/Documents/sportsceneDash/~/angularfire2/database/object/create-reference.js
// module id = ../../../../angularfire2/database/object/create-reference.js
// module chunks = 4